module.exports = __webpack_public_path__ + "static/media/logo.3d7064b5.svg";